<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true">
    <path d="M3 21 L3 14 C3 7 9 3 17 3 L21 3 L21 7 C21 15 17 21 10 21 Z"/>
    <path d="M3 21 L14 10"/>
  </svg>
</template>
